<template>
  <div class="rounded-t-md border-b border-divider bg-white px-4 py-3">
    <span class="text-sm font-semibold text-headline">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{ label: string }>();
</script>
